<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.default.tagName`),
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.name,
    }"
    class="result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:link"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <div
        v-if="searchResult.name"
        class="title"
      >
        {{ searchResult.name }}
      </div>
      <div
        v-if="searchResult.title"
        class="title"
      >
        {{ searchResult.title }}
      </div>
      <div
        v-if="searchResult.snippet"
        class="snippet"
      >
        {{ searchResult.snippet }}
      </div>
      <div
        v-if="searchResult.description"
        class="snippet"
      >
        {{ searchResult.description }}
      </div>
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';

defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.result-card {
  --background-color: #f3f6fc;
  --text-color: #1850c1;

  .title {
    line-height: 120%;
  }
  .snippet {
    line-height: 19px;
  }
}
</style>
